import {
  ValidatorFn,
  UntypedFormGroup,
  ValidationErrors,
  AbstractControl
} from '@angular/forms';

const checkAge = (countryCode: string): number => {
  const sixteenYears = 16;
  const eighteenYears = 18;
  const countriesWithAgeException = ['BR', 'CL', 'CO', 'MX', 'UY'];

  return countriesWithAgeException.find(country => country === countryCode)
    ? eighteenYears
    : sixteenYears;
};

const getDateToCompare = (minAge: number): string => {
  const ten = 10;
  const months = 12;
  const currentDate = new Date();
  const monthsAgo = currentDate.setMonth(
    currentDate.getMonth() - minAge * months
  );
  return new Date(monthsAgo).toISOString().substring(0, ten);
};

const getControlErrorsWithoutUserAdultError = (
  control: AbstractControl
): any | null => {
  const errors = { ...control.errors };

  if (control.hasError('userAdult')) {
    delete errors.userAdult;
  }
  return Object.keys(errors).length === 0 ? null : errors;
};

const changeFormatDate = (value: string): string => {
  const [day, month, year] = value.split('-');
  return `${year}-${month}-${day}`;
};

export const isInValidMinAge = (
  birthdate: string,
  countryCode: string
): boolean => {
  const minAge = checkAge(countryCode);

  // Check format date. Only Safari
  const stDatePattern =
    /^(0[1-9]|1\d|2\d|3[01])\-(0[1-9]|1[0-2])\-(19|20)\d{2}$/g;

  const birthdateValue =
    birthdate && birthdate.match(stDatePattern)
      ? changeFormatDate(birthdate)
      : birthdate;

  return birthdateValue && birthdateValue > getDateToCompare(minAge);
};

export const minAgeValidator = (): ValidatorFn => {
  return (control: UntypedFormGroup): ValidationErrors | null => {
    const birthdate = control.get('birthdate');
    const countryCode = control.get('countryCode');
    const minAge = checkAge(countryCode.value);
    const isNotOk = isInValidMinAge(birthdate.value, countryCode.value);

    const prevErrors = getControlErrorsWithoutUserAdultError(birthdate);
    const errors =
      isNotOk && !prevErrors ? { userAdult: { minAge } } : prevErrors;
    birthdate.setErrors(errors);

    return null;
  };
};
